import React from 'react';

export const ArrowRight = () => (
  <svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.3434 0.717131L14.3632 0.697848C14.9342 0.188381 15.8177 0.214791 16.3564 0.755706L25.2948 9.46231C25.8387 9.9941 25.8397 10.8537 25.2969 11.3865L16.3534 20.098C15.8147 20.6389 14.9312 20.6653 14.3602 20.1559C14.0893 19.9022 13.9362 19.5541 13.932 19.1887C13.9278 18.8233 14.0758 18.4722 14.3404 18.2144L19.6125 13.0791C19.8354 12.8619 19.9032 12.5341 19.7823 12.25C19.6615 11.9658 19.376 11.7811 19.0603 11.7821L1.67955 11.78C1.30552 11.781 0.946063 11.6339 0.684568 11.3731C0.422012 11.1133 0.277192 10.7611 0.284483 10.3968C0.317824 9.64173 0.96172 9.05107 1.73584 9.06222L19.0656 9.05729C19.3824 9.05729 19.6679 8.87257 19.7877 8.58741C19.9085 8.30324 19.8408 7.97546 19.6168 7.75928L14.3469 2.62604C13.8103 2.09731 13.8082 1.24684 14.3437 0.717068L14.3434 0.717131Z"
      fill="currentColor"
    />
  </svg>
);

export const Logo = ({
  mobileActive
}) => (
  <svg className='w-full h-auto' width="103" height="22" viewBox="0 0 103 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M102.26 7.00514V4.84787H99.4315V0.631042L96.9988 3.09921V4.09407L97.7602 4.85546H94.3974V7.01273H96.9988V14.3145C96.9988 16.0162 97.948 16.9514 99.6637 16.9514H102.231V14.7535H100.133C99.5901 14.7345 99.4264 14.5936 99.4264 14.0315V7.00892L102.26 7.00514ZM63.2515 6.05594C62.7926 5.59282 62.2455 5.22644 61.6425 4.97854C61.0388 4.73073 60.3915 4.60689 59.739 4.61436H59.6705C58.3167 4.61317 57.0163 5.14201 56.0475 6.08766V4.85546H53.6149V21.606H56.0589V15.7141C56.3906 16.0863 56.7864 16.3958 57.2277 16.6278C57.9329 16.9956 58.7164 17.188 59.5118 17.1887H59.5753C60.2521 17.1931 60.9232 17.0638 61.5498 16.808C62.1766 16.5531 62.7464 16.1761 63.2262 15.6989C63.8213 15.058 64.2825 14.3047 64.5827 13.4833C64.8823 12.662 65.0152 11.7893 64.9735 10.9161C64.99 8.9162 64.3835 7.19295 63.2515 6.05594ZM59.4065 15.0454H59.1921C58.8256 15.0468 58.4626 14.9743 58.1248 14.8322C57.7867 14.6906 57.4807 14.4821 57.2251 14.2193C56.46 13.2777 56.0424 12.1014 56.0424 10.8882C56.0424 9.67496 56.46 8.49868 57.2251 7.55712C57.4816 7.29476 57.7879 7.08639 58.1261 6.94423C58.4648 6.80225 58.8286 6.72973 59.1959 6.73102H59.4065C61.296 6.73102 62.5181 8.36547 62.5181 10.8882C62.5181 13.4109 61.2948 15.0454 59.4065 15.0454ZM39.4416 15.0454C40.7195 15.0454 41.6243 14.3754 41.8781 13.2472L41.9149 13.0645H44.3881L44.3386 13.3335C43.8869 15.657 41.9276 17.1583 39.3185 17.1583H39.25C38.545 17.1691 37.845 17.0397 37.1905 16.7776C36.5357 16.5167 35.9392 16.1285 35.4355 15.6355C34.2858 14.4934 33.7008 12.8437 33.7008 10.8666C33.6569 10.0141 33.7864 9.16147 34.0814 8.3604C34.3756 7.55883 34.8288 6.82503 35.4139 6.20313C35.9181 5.69899 36.5183 5.30114 37.179 5.03313C37.8395 4.7645 38.5473 4.63157 39.2602 4.64228C39.918 4.61058 40.5753 4.71602 41.1903 4.9519C41.8055 5.18754 42.3651 5.54837 42.8336 6.01151C43.3386 6.54172 43.7321 7.16784 43.9909 7.85281C44.2495 8.53802 44.3682 9.26808 44.3399 9.99991V11.3958H36.1258C36.2755 13.8069 37.7755 15.0454 39.2335 15.0454H39.4416ZM39.3465 6.73102H39.1358C37.6752 6.73102 36.6169 7.70306 36.2654 9.34132H41.8844C41.7499 7.72591 40.7918 6.73102 39.3452 6.73102H39.3465ZM49.5618 0.639903L47.1291 3.10807V4.22478L47.7636 4.85927H44.5302V7.01654H47.1317V14.3183C47.1317 16.02 48.0809 16.9552 49.7965 16.9552H52.3637V14.7586H50.2698C49.7267 14.7396 49.563 14.5987 49.563 14.0366V7.014H52.3916V4.85673H49.563L49.5618 0.639903ZM24.4461 5.94298C25.4203 5.04245 26.7115 4.56431 28.0373 4.61309C30.9166 4.61309 32.7325 6.1549 32.7884 8.64084V8.87307H30.3468V8.67383C30.3331 8.4011 30.2645 8.13394 30.1451 7.88834C29.9658 7.51598 29.6783 7.20639 29.3202 7.00005C28.9635 6.79462 28.553 6.70172 28.1426 6.73356H27.9358C26.7823 6.73356 25.9143 7.35027 25.9562 8.18526C25.9562 8.81975 26.2252 9.2804 27.5576 9.5545L29.3824 9.93519C30.2681 10.0817 31.096 10.4704 31.7744 11.0583C32.0895 11.3659 32.3341 11.7382 32.4914 12.1496C32.6484 12.5607 32.7151 13.0009 32.6868 13.4401C32.6868 15.6672 30.7973 17.1595 27.9815 17.1595C24.9841 17.1595 23.0895 15.6215 23.04 13.1394V12.9059H25.4587V13.1165C25.5679 14.3398 26.4739 15.0416 27.9459 15.0416H28.1502C28.6941 15.0647 29.2316 14.9179 29.6882 14.6216C29.8612 14.5064 30.0025 14.3498 30.0994 14.166C30.1958 13.9817 30.2442 13.7762 30.2402 13.5683C30.2402 13.0252 30.0537 12.4821 28.6845 12.1991L26.9916 11.8565C26.0655 11.7011 25.1957 11.3075 24.4676 10.7144C24.1385 10.4195 23.8785 10.0554 23.7063 9.6484C23.5348 9.24146 23.4555 8.80161 23.474 8.3604C23.4607 7.9109 23.5397 7.46343 23.7063 7.04572C23.8742 6.62991 24.1256 6.2529 24.4448 5.9379L24.4461 5.94298ZM81.2063 0.75413H78.7724V3.47101H81.2051L81.2063 0.75413ZM87.4713 4.97349C88.0937 4.71145 88.7659 4.58845 89.4408 4.61309C92.1056 4.61309 93.8175 6.32368 93.8289 8.95554V16.9324H91.3963V9.43522C91.3963 7.62185 90.6412 6.73356 89.1121 6.73356H88.9433C87.1414 6.73356 85.8318 8.28553 85.8318 10.4263V16.9463H83.3903V4.85419H85.828V6.12317C86.2845 5.62299 86.845 5.22885 87.47 4.96841L87.4713 4.97349ZM81.2063 4.8466H78.7724V16.94H81.2051L81.2063 4.8466ZM71.576 4.61817C72.3036 4.60935 73.0257 4.74521 73.7003 5.01789C74.3755 5.29159 74.9894 5.69712 75.5061 6.21075C76.6712 7.4925 77.3168 9.16241 77.3169 10.8946C77.3168 12.6267 76.6712 14.2966 75.5061 15.5784C75.0037 16.0822 74.4069 16.4819 73.7498 16.7547C73.0929 17.0271 72.3887 17.1673 71.6776 17.1671H71.472C70.764 17.1671 70.0631 17.0265 69.4099 16.7534C68.7564 16.4807 68.1634 16.0814 67.665 15.5784C66.4962 14.2974 65.8481 12.6261 65.8479 10.892C65.8479 9.15792 66.496 7.48645 67.665 6.20567C68.1766 5.69166 68.7864 5.28596 69.4581 5.01281C70.1295 4.73825 70.8495 4.6023 71.5748 4.61309L71.576 4.61817ZM71.4745 15.0492H71.6814C73.5937 15.0492 74.8716 13.3792 74.8716 10.892C74.8716 8.40481 73.5798 6.73483 71.6763 6.73483H71.453C69.5495 6.73483 68.2805 8.40481 68.2805 10.892C68.2805 13.3792 69.5584 15.0454 71.4733 15.0454L71.4745 15.0492Z"
      fill={`${mobileActive ? '#ffffff' : '#071B1E'}`}
    />
    <path
      d="M0.5 1.8465V19.8826H18.5377V1.8465H0.5ZM17.1083 18.4548H11.9899V13.3364L7.04945 18.2769H2.10896V13.3364L7.04945 8.39595V13.3364H11.9899V8.39595H1.92945V3.27264H7.0478V8.391L11.9883 3.45051H16.9288V8.391L11.9883 13.3315H17.1066L17.1083 18.4548Z"
      fill={`${mobileActive ? '#ffffff' : '#071B1E'}`}
    />
  </svg>
);

export const Check = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4.66647" cy="4.79659" r="4.58834" fill="#4FEDC7"/>
    <path d="M2.83105 5.05882L3.87987 6.10763L6.50191 3.4856" stroke="white" strokeWidth="0.524408" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
export const CoralCheck = () => (
  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9.5" r="9" fill="#FC9082"/>
    <path d="M4.63836 9.52862L6.87066 12.3382L13.7958 6.62861" stroke="white" strokeWidth="2.13723"/>
  </svg>
)

export const CheckLrg = () => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="21.0812" cy="20.7462" r="20.5064" fill="#2C9C88"/>
    <circle cx="21.0812" cy="20.7462" r="19.6176" stroke="white" strokeOpacity="0.3" strokeWidth="1.77778"/>
    <path d="M12.5293 22.6491L17.3409 27.4606L29.5231 15.2783" stroke="white" strokeWidth="1.76133"/>
  </svg>
);

export const CheckAuto = () => (
  <svg className='w-full h-auto' width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="21.0812" cy="20.7462" r="20.5064" fill="#2C9C88"/>
    <circle cx="21.0812" cy="20.7462" r="19.6176" stroke="white" strokeOpacity="0.3" strokeWidth="1.77778"/>
    <path d="M12.5293 22.6491L17.3409 27.4606L29.5231 15.2783" stroke="white" strokeWidth="1.76133"/>
  </svg>
);

export const FormCheck = () => (
  <svg className='w-full h-full' width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="21.0812" cy="20.7462" r="20.5064" fill="#2C9C88"/>
    <circle cx="21.0812" cy="20.7462" r="19.6176" stroke="white" strokeOpacity="0.3" strokeWidth="1.77778"/>
    <path d="M12.5293 22.6491L17.3409 27.4606L29.5231 15.2783" stroke="white" strokeWidth="1.76133"/>
  </svg>
);

export const VideoPlay = () => (
  <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="29" cy="29" r="29" fill="#FC9082"/>
    <g clipPath="url(#clip0_1315_1166)">
    <path d="M34.741 28.5631L24.741 23.0631C24.6643 23.0204 24.5777 22.9987 24.4899 23.0001C24.4022 23.0015 24.3163 23.026 24.241 23.0711C24.1671 23.1158 24.1061 23.1789 24.0638 23.2543C24.0216 23.3297 23.9996 23.4147 24 23.5011V34.5011C24.0001 34.5879 24.0229 34.6733 24.066 34.7487C24.1091 34.8241 24.1712 34.8869 24.246 34.9311C24.3227 34.9771 24.4105 35.0013 24.5 35.0011C24.5843 35.001 24.6672 34.9797 24.741 34.9391L34.741 29.4391C34.8194 29.3959 34.8848 29.3325 34.9303 29.2554C34.9758 29.1784 34.9999 29.0906 34.9999 29.0011C34.9999 28.9116 34.9758 28.8237 34.9303 28.7467C34.8848 28.6696 34.8194 28.6062 34.741 28.5631Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_1315_1166">
    <rect width="12" height="12" fill="white" transform="translate(23 23)"/>
    </clipPath>
    </defs>
  </svg>
);

export const VideoIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3095_4465)">
    <path d="M31.8223 3.85449H3.38477C2.17664 3.85449 1.19727 4.83387 1.19727 6.04199V30.1045C1.19727 31.3126 2.17664 32.292 3.38477 32.292H31.8223C33.0304 32.292 34.0098 31.3126 34.0098 30.1045V6.04199C34.0098 4.83387 33.0304 3.85449 31.8223 3.85449Z" stroke="#FC9082" strokeWidth="2.1875" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.1348 10.417L24.166 18.0732L12.1348 25.7295V10.417Z" stroke="#FC9082" strokeWidth="2.1875" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <rect x="1.19727" y="1.66699" width="32.8125" height="32.8125" stroke="white" strokeOpacity="0.3" strokeWidth="2.1875"/>
    <defs>
    <clipPath id="clip0_3095_4465">
    <rect x="0.103516" y="0.573242" width="35" height="35" fill="white"/>
    </clipPath>
    </defs>
  </svg>
);

export const Chevron = ({color="#164951"}) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M9.36324 4.92549L4.87983 9.4089L0.396484 4.92549L1.24502 4.07697L4.87984 7.71184L8.51471 4.07697L9.36324 4.92549Z" fill={color}/>
  </svg>
);

export const ChevronRight = () => (
  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 10L4.85714 5.5L1 1" stroke="currentColor" strokeWidth="1.92857"/>
  </svg>
)

export const ButtonArrow = () => {
  return (
    <svg className={`w-full h-full max-w-[24px] max-h-[24px]`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill={'#F66B4C'} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2378 8.1591L16.8345 11.6159C17.0552 11.828 17.0552 12.172 16.8345 12.3841L13.2378 15.8409C13.0171 16.053 12.6592 16.053 12.4385 15.8409C12.2178 15.6288 12.2178 15.2849 12.4385 15.0727L15.0704 12.5432H6V11.4568H15.0704L12.4385 8.92728C12.2178 8.71515 12.2178 8.37122 12.4385 8.1591C12.6592 7.94697 13.0171 7.94697 13.2378 8.1591Z"
        fill='white'
      />
    </svg>
  );
};

export const SwiperArrow = () => {
  return (
    <svg width="29" height="8" viewBox="0 0 29 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.875 7.10059L27.875 4.10059L24.875 1.10059" stroke="#164951" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M28 4.10059L1 4.10059" stroke="#164951" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export const ButtonArrowUnset = ({ color, arrowFill }) => {
  return (
    <svg className={`w-full h-full`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill={arrowFill ? '#FC9082' :'currentColor'} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2378 8.1591L16.8345 11.6159C17.0552 11.828 17.0552 12.172 16.8345 12.3841L13.2378 15.8409C13.0171 16.053 12.6592 16.053 12.4385 15.8409C12.2178 15.6288 12.2178 15.2849 12.4385 15.0727L15.0704 12.5432H6V11.4568H15.0704L12.4385 8.92728C12.2178 8.71515 12.2178 8.37122 12.4385 8.1591C12.6592 7.94697 13.0171 7.94697 13.2378 8.1591Z"
        fill={`${color === 'coral' ? 'black' : 'white'}`}
      />
    </svg>
  );
};

export const FileUpload = ({}) => (
  <svg className='!w-full' width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.8047 9.10405L16.9991 2.90967L23.1935 9.10405" fill="white"/>
    <path d="M10.8047 9.10405L16.9991 2.90967L23.1935 9.10405" stroke="#FC9082" strokeWidth="2.03" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.8708 16.3311H6.67646L2.54688 31.3008H31.454L27.3244 16.3311H21.13" fill="white"/>
    <path d="M12.8708 16.3311H6.67646L2.54688 31.3008H31.454L27.3244 16.3311H21.13" stroke="#FC9082" strokeWidth="2.03" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 24.59V2.90967" stroke="#FC9082" strokeWidth="2.03" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const Close = ({}) => {
  return (
    <svg className='w-full h-full' width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25.3538" cy="25.3538" r="25.3538" fill="#FC9082"/>
      <path d="M17.2188 17.2173L33.4915 33.4901" stroke="white" strokeWidth="2"/>
      <path d="M33.4922 17.2173L17.2194 33.4901" stroke="white" strokeWidth="2"/>
    </svg>
  );
};

export const Arrow = ({ active }) => {
  return(
    <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.7535 0.55937L15.8488 5.45652C16.1615 5.75704 16.1615 6.24427 15.8488 6.54478L10.7535 11.4419C10.4409 11.7424 9.93391 11.7424 9.62124 11.4419C9.30857 11.1414 9.30857 10.6542 9.62124 10.3537L13.3497 6.77016H0.5V5.23114H13.3497L9.62124 1.64763C9.30857 1.34711 9.30857 0.859884 9.62124 0.55937C9.93391 0.258856 10.4409 0.258856 10.7535 0.55937Z"
      fill={`${active ? 'white' : 'black' }`}/>
    </svg>
  );
};

export const LinkedinWhite = ({ classes }) => {
  return(
    <svg className={classes} width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.59185 22.7992H0.964385V7.89748H5.59185V22.7992ZM3.27563 5.86475C1.79591 5.86475 0.595703 4.63913 0.595703 3.15941C0.595703 2.44865 0.878051 1.76701 1.38063 1.26442C1.88322 0.76184 2.56487 0.479492 3.27563 0.479492C3.98638 0.479492 4.66803 0.76184 5.17062 1.26442C5.6732 1.76701 5.95555 2.44865 5.95555 3.15941C5.95555 4.63913 4.75484 5.86475 3.27563 5.86475ZM22.9109 22.7992H18.2935V15.5451C18.2935 13.8163 18.2586 11.5993 15.8876 11.5993C13.4816 11.5993 13.113 13.4775 13.113 15.4206V22.7992H8.49049V7.89748H12.9286V9.93022H12.9934C13.6112 8.7594 15.1203 7.52382 17.3717 7.52382C22.055 7.52382 22.9159 10.6078 22.9159 14.6135V22.7992H22.9109Z" fill="white"/>
    </svg>
  );
};

export enum IconType {
  None = 'none',
  ArrowRight = 'arrowRight',
}

const IconMap = {
  arrowRight: ArrowRight,
};

interface IconProps {
  type: string;
}

export const Icon = ({ type }: IconProps) => {
  if (type === IconType.None || !type) return null;
  return IconMap[type]();
};
